import styled from '@emotion/styled';

import theme from '@app/styles/theme';

export default styled.span`
  display: inline-block;
  border-bottom: 3px solid transparent;
  border-right: 6px solid ${theme.colors.lightBlue};
  border-top: 3px solid transparent;
  height: 0;
  width: 0;
`;
